import React, { useCallback } from 'react'
import { Checkbox, Tooltip } from 'antd'
import PropTypes from 'prop-types'

import { useUpdateLocationsStatusFlagsMutation } from '../../hooks'

const LocationStatusCheckbox = ({
  locationIds,
  statusFlagFieldName,
  value,
  disabled,
  tooltip,
}) => {
  const [updateStatusFlag] =
    useUpdateLocationsStatusFlagsMutation(statusFlagFieldName)

  const handleChange = useCallback(
    event => updateStatusFlag(locationIds, event.target.checked),
    [locationIds, updateStatusFlag],
  )

  return (
    <Tooltip title={tooltip}>
      <Checkbox checked={value} onChange={handleChange} disabled={disabled} />
    </Tooltip>
  )
}

LocationStatusCheckbox.propTypes = {
  locationIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  statusFlagFieldName: PropTypes.string.isRequired,
  value: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  tooltip: PropTypes.string,
}

LocationStatusCheckbox.defaultProps = {
  disabled: false,
  tooltip: undefined,
}

export default LocationStatusCheckbox
